import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

const Title = (props) => {
    const { mainTitles, titleClass, titletop, titlebottom, fontSizeParagraph, titlerimac, soat, placa } = props;

    const [ titleMain, setTitleMain ] = useState('');

    useEffect(() => {
        if (soat && mainTitles) {
            mainTitles.map(item => {
                if (item.key === soat) {
                    setTitleMain(item.title);
                }
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [soat]); 

    const replaceText = (text) => {
        return text ? text.replace("[placa]", placa) : '';
    }

    return (
        <div
            className={`titleComponent ${titleClass || ''} ${titletop || ''} ${titlebottom || ''} ${fontSizeParagraph || ''}`}
            dangerouslySetInnerHTML={{ __html: replaceText(titlerimac) || titleMain }}
        />
    );
}

const mapStateToProps = ({ consultReducer }) => {
    return {
        soat: consultReducer.statusSOAT,
        placa: consultReducer.plateFormat,
    };
};

const mapDsipatchToProps = (dispatch) => {
    return {};
};

const TitleR = connect(mapStateToProps, mapDsipatchToProps)(Title);


export default TitleR;
